"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getLanguage = getLanguage;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vue = _interopRequireDefault(require("vue"));
var _vueI18n = _interopRequireDefault(require("vue-i18n"));
var _en = _interopRequireDefault(require("element-ui/lib/locale/lang/en"));
var _zhCN = _interopRequireDefault(require("element-ui/lib/locale/lang/zh-CN"));
var _en2 = _interopRequireDefault(require("./en"));
var _cn = _interopRequireDefault(require("./cn"));
// element-ui lang
// element-ui lang

_vue.default.use(_vueI18n.default);
var messages = {
  en: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _en2.default), _en.default),
  cn: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _cn.default), _zhCN.default)
};
function getLanguage() {
  var chooseLanguage = localStorage.getItem('language') || 'cn';
  return chooseLanguage;
}
var i18n = new _vueI18n.default({
  // set locale
  // options: en | cn | es
  locale: getLanguage(),
  // set locale messages
  messages: messages
});
var _default = exports.default = i18n;